import Link from "next/link";
import React from "react";
import { useTranslations } from "next-intl";

const HYPERLINK_CONFIG = {
  sink: {
    color:
      "text-forest-700 dark:text-forest-300 hover:underline font-semibold transition-colors",
    href: (refId: string) => `/sink/${refId}`,
    tooltipKey: "common.hyperlink.forestTooltip",
  },
  pd: {
    color:
      "text-timber-700 dark:text-timber-300 hover:underline font-semibold transition-colors",
    href: (refId: string) => `/developer/${refId}`,
    tooltipKey: "common.hyperlink.pdTooltip",
  },
  b: {
    color:
      "text-blue-700 dark:text-blue-300 hover:underline font-semibold transition-colors",
    href: (refId: string) => `/beneficiary/${refId}`,
    tooltipKey: "common.hyperlink.bTooltip",
  },
};

interface HyperLinkProps {
  type: "sink" | "pd" | "b";
  refId: string;
  children: React.ReactNode;
  className?: string;
}

export const HyperLink = ({
  type,
  refId,
  children,
  className = "",
}: HyperLinkProps) => {
  const config = HYPERLINK_CONFIG[type];
  const t = useTranslations();
  if (!config) {
    return <span className={`text-gray-500 ${className}`}>{children}</span>;
  }
  return (
    <Link
      href={config.href(refId)}
      className={`${config.color} ${className}`}
      title={t(config.tooltipKey)}
    >
      {children}
    </Link>
  );
};
